import type { CurrenciesResponseModel } from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const currencyQueries = {
	list: () => ({
		queryKey: ['currencies'],
		queryFn: () => client.currencies.getCurrencies(),
		staleTime: 60 * 60 * 1000,
		retry: 1,
	}),
}

export const useCurrenciesQuery = <T = CurrenciesResponseModel>(
	options?: UseQueryOptions<CurrenciesResponseModel, Error, T>
) =>
	useQuery<CurrenciesResponseModel, Error, T>({
		...currencyQueries.list(),
		...(options || {}),
	})
